// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"417":"1c763c41","867":"75fae3c0"}[chunkId] + ".chunk.js";
};